import {GenericDevice} from "@/data/models/GenericDevice";

export interface ImportProgress {
  totalDevices: number;
  processedDevices: number;
  duplicatedDevices: number;
  newDevices: number;
  updatedDevices: number;
  errors: ImportError[];
  /**
   * Contains the generated import report including headers as a string array
   */
  report?: string[] | null;
  /**
   * Indicates if too many devices have not been imported due to errors.
   */
  criticalFailure: boolean;
  /**
   * When true, this progress update is from a dry-run (preview) — no data was written to Firestore.
   */
  dryRun: boolean;
}

export enum ImportErrorType {
  MISSING_INVENTORY_NUMBER,
  MISSING_CATEGORY,
  MISSING_DEVICE_TEMPLATE,
  CATEGORY_NOT_FOUND,
  TEMPLATE_NOT_FOUND,
  CATEGORY_UPDATE,
  TEMPLATE_UPDATE,
  SERVER_ERROR,
  IRES_DEVICE,
  DEVICE_DOES_NOT_EXIST,
  INVALID_INVENTORY_NUMBER,
  INVALID_QR_CODE,
  INVENTORY_NUMBER_ALREADY_EXISTS,
  QR_CODE_ALREADY_EXISTS,
  INVALID_MANUFACTURER,
  INVALID_POWER_CONSUMPTION_PER_HOUR,
  INVALID_DEVICE_POWER_USAGE_TYPE,
  INVALID_ELECTRICITY_MANUFACTURER,
  DEVICE_ASSIGNED_TO_PROJECT,
  /** The STANDORT column names no branch of the client. */
  BRANCH_NOT_FOUND
}
export enum ImportResult {
  UPDATED="UPDATED",
  NEW="NEW",
  NO_CHANGE="NO CHANGE",
  ERROR="ERROR",
  DELETED="DELETED",
  RESTORED="RESTORED",
  DUPLICATE="DUPLICATE"
}

export interface ImportError {
  inventoryNumber: string;
  message: ImportErrorType;
  /** Identifier of the conflicting device (inventory number or serial number) for duplicate errors */
  conflictingDeviceId?: string;
}

export interface DeviceUpdate {
  oldDevice: GenericDevice;
  newDevice: GenericDevice;
}